import React, { useEffect, useState } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { can } from "../../utils/can";

export default function AboutUs() {
  const API_URL = process.env.REACT_APP_BASE_URL_API || "";
  const token = localStorage.getItem("adminToken");
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [filepath, setFilepath] = useState("");

  const [form, setForm] = useState({
          aboutContent: "",
          mission: "",
          vision: "",
          image: null
        });

  const [loading, setLoading] = useState(false);

  /* ================= FETCH DATA ================= */
  const fetchAbout = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/api/admin/about-us-list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await res.json();

    if (result.success && result.data) {
      const about = result.data;

      setForm({
        aboutContent: about[0].aboutContent || "",
        mission: about[0].ourMission || "",
        vision: about[0].ourVision || ""
      });

      setFilepath(about[0].aboutImage || "");
    }
      
    } catch (err) {
      console.error("Fetch error", err);
    } finally {
      console.log("Fetch about us data completed");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAbout();
  }, []);

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  /* ================= UPDATE ================= */
  const handleSubmit = async (e) => {
  e.preventDefault();

  if (can("about_us", "edit") === false) {
    alert("You don't have permission.");
    return;
  }

  // Reset previous errors
  setErrors({});

  const newErrors = {};

  if (!form.aboutContent) {
    newErrors.aboutContent = "About content is required";
  }

  if (!form.mission) {
    newErrors.mission = "Mission is required";
  }

  if (!form.vision) {
    newErrors.vision = "Vision is required";
  }

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  const formData = new FormData();
  formData.append("aboutContent", form.aboutContent);
  formData.append("mission", form.mission);
  formData.append("vision", form.vision);
  formData.append("filepath", filepath); // Send existing image path
  // ✅ Append image only if selected
  if (form.image) {
      formData.append("image", form.image);
    }

  try {
    setLoading(true);

    const res = await fetch(`${API_URL}/api/admin/about-us-create`, {
      method: "POST", // upsert
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    const data = await res.json();

    if (data.success) {
      setMessage("About Us updated successfully");
    } else {
      alert(data.message || "Update failed");
    }

  } catch (err) {
    console.error("Update error:", err);
    alert("Server error");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="container body">
      <div className="main_container">
        <Sidebar />
        <Header pageTitle="About Us" />

        <div className="right_col" role="main">
         

          <div className="x_panel">
            <div className="x_title">
              <h2>Entry</h2>
              <div className="clearfix" />
            </div>

            <div className="x_content">
              <form onSubmit={handleSubmit}>
                <div className="filtercont">
                <div className="row">

                  <div className="col-sm-4 mb-3">
                    <label>About Image</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={(e) =>
                        setForm({ ...form, image: e.target.files[0] })
                      }
                    />
                    {errors.aboutImage && (
                      <div className="text-danger">{errors.aboutImage}</div>
                    )}
                  </div>

                  <div className="col-sm-4 mb-3">
                    <label>About Content</label>
                    <textarea
                      className="form-control"
                      name="aboutContent"
                      value={form.aboutContent}
                      onChange={handleChange}
                    />
                    {errors.aboutContent && (
                      <div className="text-danger">{errors.aboutContent}</div>
                    )}
                  </div>

                  <div className="col-sm-4 mb-3">
                    <label>Our Mission</label>
                    <textarea
                      className="form-control"
                      name="mission"
                      value={form.mission}
                      onChange={handleChange}
                    />
                    {errors.mission && (
                      <div className="text-danger">{errors.mission}</div>
                    )}
                  </div>

                  <div className="col-sm-4 mb-3">
                    <label>Our Vision</label>
                    <textarea
                      className="form-control"
                      name="vision"
                      value={form.vision}
                      onChange={handleChange}
                    />
                    {errors.vision && (
                      <div className="text-danger">{errors.vision}</div>
                    )}

                  </div>
                
                

                  <div className="col-12 text-right">
                    <button className="btn sitebtn" disabled={loading}>
                      {loading ? "Updating..." : "Update"}
                    </button>
                  </div>

                  {message && (
                    <div className="col-12 mt-2 text-success">
                      {message}
                    </div>
                  )}

                </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}
